export const userResponse = `user {
  sub
  balance
  email
  updatedAt
  isAdmin
  planname
  stripePaymentMethodId
  stripeCustomerId
  cancelAtPeriodEnd
  currentPeriodEnd
  affiliateId
  referrerAffiliateId
  subscriptions {
    id
  }
  customer {
    id
  }
  settings {
    data
  }
  deviceOrders {
    timestamp
    status
    sub
    trackingNumber
    notes
  }
}
`;

export const getMe = `query GetMe {
  getMe {
    ${userResponse}  }
}`;

export const createCheckoutSession = `query CreateCheckoutSession($priceId: String) {
  createCheckoutSession(priceId: $priceId) {
    url
  }
}`;

export const createCustomerPortalSession = `query createCustomerPortalSession {
  createCustomerPortalSession {
    url
  }
}`;

export const createCheckoutSessionForDevicePurchase = `query CreateCheckoutSessionForDevicePurchase ($priceId: String) {
  createCheckoutSessionForDevicePurchase(priceId: $priceId) {
    url
  }
}`;

export const getDeviceOrders = `query GetDeviceOrders ($getDeviceOrdersInput: GetDeviceOrdersInput!) {
  getDeviceOrders (getDeviceOrdersInput: $getDeviceOrdersInput) {
    timestamp
    status
    sub
    trackingNumber
    notes
    name
    city
    country
    line1
    line2
    postal_code
    state
    email
  }
}`;

export const getWaitlistStatus = `query GetWaitlistStatus {
  getWaitlistStatus {
    howManyAhead
    currentlyInLine
    stockOnHand
  }
}`;
